export default __webpack_public_path__ + "static/media/ossscreen6.70e3a49f.png";